<div class="dv-checkbox-form-group" [ngClass]="{horizontal: horizontal}">
    <ng-content></ng-content>
</div>
